import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';

class HeaderDetailText extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { data } = this.props;
        return (
            <div className='row d-flex flex-column flex-md-row justify-content-center'>
                {
                    data.map((elem, index) => {
                        return (
                            <div className='md-4 p-4 text-center d-flex flex-column justify-content-between' key={elem.headerTxt}>
                                <h2>{elem.headerTxt}</h2>
                                <p dangerouslySetInnerHTML={{ __html: elem.detailTxt }}></p>
                                <div className="mt-3"><img src={elem.iconImage} alt="" className="flex-shrink-1" /></div>
                            </div>);
                    })
                }
            </div>
        );
    }
}

export default branch({
}, HeaderDetailText);



// WEBPACK FOOTER //
// ./src/pages/components/page/HeaderDetailText.js